import { Col, Row } from "react-bootstrap";
import { ReactComponent as LeapLogoVector } from "../../../../../src/assets/img/leap/leap-logo.svg";

interface IEtsHeaderComponentProps {
  headerContent: JSX.Element;
}

const EtsHeaderComponent = ({ headerContent }: IEtsHeaderComponentProps) => {
  return (
    <div className="ms-3 me-3">
      <Row>
        <Col className="col-12">
          <div style={{ marginBottom: "1rem" }}>
            <LeapLogoVector
              style={{ height: "50px", width: "auto" }}
              className="d-none d-md-none d-sm-inline"
            />
            <LeapLogoVector
              style={{ height: "40px", width: "auto" }}
              className="d-inline d-sm-none"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          className="col-12 col-sm-12 col-md-6"
          style={{ paddingLeft: "1.3rem" }}
        >
          {headerContent}
        </Col>
        <Col
          className="col-12 col-sm-12 col-md-6"
          style={{ textAlign: "right", paddingRight: "1rem" }}
        ></Col>
      </Row>
    </div>
  );
};

export default EtsHeaderComponent;
